import { render, staticRenderFns } from "./RgObjectListContainer.vue?vue&type=template&id=3fbb9a86&"
import script from "./RgObjectListContainer.vue?vue&type=script&lang=js&"
export * from "./RgObjectListContainer.vue?vue&type=script&lang=js&"
import style0 from "./RgObjectListContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports